import { createSlice } from '@reduxjs/toolkit';
import { ProductsGridStateType } from 'src/types/productsGrid';

const initialState: ProductsGridStateType = {
    data: null,
    allProviders: false,
    loading: false,
    error: false,
};
export const productsGridSlice = createSlice({
    name: 'productsGrid',
    initialState,
    reducers: {
        getProductsGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            if (action.payload) {
                state.allProviders = action.payload.allProviders;
            }
        },
        getProductsGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductsGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProductsGridFetch,
    getProductsGridFetchSuccess,
    getProductsGridFetchFailure,
} = productsGridSlice.actions;

export default productsGridSlice.reducer;
